import React from 'react';
export const LegendFeatureReleaseIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={16}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 10.8C11.6558 10.8 11.3121 10.7016 11.0117 10.5047L6.18318 7.33204C5.67498 6.99845 5.37146 6.43673 5.37146 5.82891C5.37107 5.22032 5.67459 4.65781 6.18279 4.32344L11.0117 1.15078C11.6117 0.757031 12.3875 0.757031 12.9883 1.15078L17.8168 4.32344C18.3254 4.65781 18.6289 5.22031 18.6285 5.82891C18.6285 6.43673 18.325 6.99844 17.8168 7.33204L12.9883 10.5047C12.6883 10.7016 12.3441 10.8 12 10.8ZM11.6703 9.50157C11.8703 9.63282 12.1297 9.63282 12.3297 9.50157L17.1582 6.32891C17.33 6.21641 17.4285 6.0336 17.4285 5.82813C17.4285 5.62265 17.33 5.43985 17.1578 5.32657L12.3297 2.15391C12.1297 2.02266 11.8703 2.02266 11.6703 2.15391L6.84176 5.32657C6.66989 5.43985 6.57145 5.62266 6.57145 5.82813C6.57145 6.03359 6.66989 6.21641 6.84176 6.32891L11.6703 9.50157Z"
      fill="black"
    />
    <path
      d="M12 15.1999C11.6558 15.1999 11.3121 15.1014 11.0117 14.9046L6.18318 11.7319C5.72146 11.4288 5.42927 10.9397 5.38239 10.3921C5.33474 9.83661 5.53982 9.30067 5.94489 8.92099C6.18669 8.6952 6.56676 8.70771 6.79294 8.94911C7.0195 9.1913 7.007 9.57099 6.7652 9.79755C6.63004 9.92334 6.56207 10.103 6.57809 10.289C6.58707 10.3944 6.63317 10.5921 6.84176 10.7288L11.6703 13.9015C11.8703 14.0327 12.1297 14.0327 12.3297 13.9015L17.1582 10.7288C17.3668 10.5921 17.4132 10.3944 17.4222 10.289C17.4382 10.103 17.3699 9.92412 17.2347 9.79755C16.9929 9.57099 16.9804 9.19131 17.207 8.94911C17.4335 8.70771 17.8136 8.69521 18.055 8.92099C18.4605 9.30067 18.6656 9.83661 18.6179 10.3921C18.5707 10.9405 18.2785 11.4288 17.8168 11.7319L12.9882 14.9046C12.6882 15.1014 12.3441 15.1999 12 15.1999Z"
      fill="black"
    />
  </svg>
);
